import { seoBrandCategoriesState } from './state';

export default (placeholder) => ({
  state: seoBrandCategoriesState(placeholder),
  namespaced: true,
});
